'use client'

import { useLayoutEffect } from 'react'
import { usePathname } from 'next/navigation'

/**
 * ScrollToTop component that ensures the page scrolls to top on route changes.
 * This handles both Link navigation and router.push/replace calls.
 *
 * Uses useLayoutEffect to run synchronously before browser paint,
 * preventing any visual "jump" when navigating to a new route.
 */
export default function ScrollToTop() {
    const pathname = usePathname()

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    return null
}
